import {
  faTrash,
  faUser,
  faExclamationCircle,
  faPaperPlane,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { Fragment, useEffect, useState, useRef } from "react";
import GetStudentService from "../../../services/SchoolIT/GetStudentService";
import moment from "moment";
import CreateMessage from "./CreateMessage";
import CannedModal from "./CannedModal";
import CustomLoader from "../../customLoader/CustomLoader";
import AppHeader from "../../../Layout/AppHeader";
import AppSidebar from "../../../Layout/AppSidebar";
import { useLocation } from "react-router";
import MsgDataService from "../../../services/MsgService";
import MessageSendSpinner from "../../shared/MessageSendSpinner";
import { useDispatch } from "react-redux";
import { messageNotificationAction } from "../../../reducers/MessageNotificationReducer";
import swal from "sweetalert";
import "./StudentMessage.css";

const IMG_URL = process.env.REACT_APP_IMAGE_ASSET_URL;

const StudentMessage = () => {
  let location = useLocation();
  const dispatch = useDispatch();
  const threadEndRef = useRef(null);
  const [user] = useState(
    localStorage.getItem("user") && JSON.parse(localStorage.getItem("user"))
  );
  const [page] = useState(1);
  const [messageDetails, setMessageDetails] = useState([]);
  const [singleMessageOpen, setSingleMessageOpen] = useState(
    location?.state?.open ? location?.state?.open : false
  );
  const [singleMessageValue, setSingleMessageValue] = useState(
    location?.state?.state
  );
  const [allMessageValue, setAllMessageValue] = useState();
  const [message, setMessage] = useState("");
  const [sending, setSending] = useState(false);
  const [openCreateNewMessage, setOpenCreateNewMessage] = useState(
    location?.state?.openCreateMessage
      ? location?.state?.openCreateMessage
      : false
  );
  const [openCannedModal, setOpenedCannedModal] = useState(false);
  const [messageIndex, setMessageIndex] = useState(
    location?.state?.index ? location?.state?.index : -1
  );
  const [messageValueForCreateMessage, setMessageValueForCreateMessage] =
    useState("");
  const [loading, setLoading] = useState(false);
  const [selectedMessageFromScheduled, setSelectedMessageFromScheduled] =
    useState(false);
  const [selectedMessage, setSelectedMessage] = useState();
  const [notificationData, setNotificationData] = useState(null);
  const [threadLoading, setThreadLoading] = useState(false);

  const getNotificationData = () => {
    MsgDataService.getCounselorNotificationCount()
      .then((res) => {
        if (res?.status === 200) {
          setNotificationData(res?.data || null);
          const total = res?.data?.total_notification ?? 0;
          try {
            dispatch(messageNotificationAction(total));
          } catch (_) {}
        }
      })
      .catch(() => {});
  };

  const getUnreadCountForItem = (item) => {
    if (!notificationData || !item) return 0;
    const studentId = item?.src_id ?? item?.id;
    if (studentId === undefined || studentId === null) return 0;

    // Counts for school_it student messages come under `student` keyed by id
    const map =
      notificationData.student ||
      notificationData.school_it ||
      {};
    return (
      Number(map[studentId] ?? map[String(studentId)] ?? 0) || 0
    );
  };

  const totalUnread = Number(notificationData?.total_notification || 0);

  const getStudentMessage = () => {
    setLoading(true);
    let obj = {
      counselor_id: user?.counselor_id,
      event_type: "school_it_student",
      page: page,
      school_id: user?.school_id,
    };
    GetStudentService.getMessageForStudentInIT(obj)
      .then((data) => {
        setMessageDetails(data?.data?.data || []);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const deleteStudentMessage = async (e, value) => {
    e?.stopPropagation?.();
    const confirmed = await swal({
      title: "Delete?",
      text: "Are you sure you want to delete this conversation?",
      icon: "warning",
      buttons: {
        cancel: "Cancel",
        confirm: "Yes, Delete",
      },
      dangerMode: true,
      closeOnClickOutside: false,
    });
    if (!confirmed) return;

    let body = {
      id: value?.id,
      type: "student",
    };
    GetStudentService.deleteMessageForStudent(body)
      .then(() => {
        getStudentMessage();
        getNotificationData();
        setSingleMessageValue();
        setSingleMessageOpen(false);
        setSelectedMessage();
        setMessageIndex(-1);
      })
      .catch(() => {});
  };

  const markConversationRead = (item) => {
    const srcId = item?.src_id || item?.id;
    if (!srcId) return;
    MsgDataService.counselorReadMessage({ src_id: String(srcId) })
      .then(() => getNotificationData())
      .catch(() => {});
  };

  const getSelectedContactMessageDetail = (item) => {
    setThreadLoading(true);
    GetStudentService.getMessageListPerUser(page, item.src_id)
      .then((data) => {
        setSingleMessageValue(data?.data?.messages || []);
      })
      .catch(() => {
        setSingleMessageValue([]);
      })
      .finally(() => setThreadLoading(false));
  };

  const handleSinglePage = (item, index) => {
    setSingleMessageOpen(true);
    setSelectedMessage(item);
    setMessageIndex(index);
    setMessage("");
    getSelectedContactMessageDetail(item);
    markConversationRead(item);
  };

  const isReceivedMessage = (item) => {
    if (!item) return true;
    const studentSrc = selectedMessage?.src_id;
    if (studentSrc != null && item?.src_id != null) {
      return String(item.src_id) === String(studentSrc);
    }
    if (selectedMessage?.name && item?.src_name) {
      return item.src_name === selectedMessage.name;
    }
    if (item?.src_role) {
      return String(item.src_role).toLowerCase() === "student";
    }
    if (user?.id != null && item?.src_id != null) {
      return String(item.src_id) !== String(user.id);
    }
    return true;
  };

  const sendMessage = (e) => {
    if (e?.preventDefault) e.preventDefault();
    if (sending) return;
    if (!message || message.trim() === "" || message === "undefined") return;

    let obj = {
      message_body: message,
      dst_id: [selectedMessage?.src_id],
      event_type: "school_it_student",
    };
    setSending(true);
    MsgDataService.sendMessage(obj)
      .then(() => {
        setMessage("");
        getSelectedContactMessageDetail(selectedMessage);
        getStudentMessage();
        getNotificationData();
      })
      .catch(() => {})
      .finally(() => setSending(false));
  };

  const createNewMessage = () => {
    setOpenCreateNewMessage(true);
  };

  const handleCannedMessageSelect = (value) => {
    setMessageValueForCreateMessage(value?.messages?.en?.body);
    setSelectedMessageFromScheduled(true);
    setOpenedCannedModal(false);
    setAllMessageValue(value);
  };

  useEffect(() => {
    getStudentMessage();
    getNotificationData();
  }, []);

  useEffect(() => {
    if (threadEndRef.current) {
      threadEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [singleMessageValue, threadLoading]);

  const conversationName =
    selectedMessage?.name ||
    singleMessageValue?.[0]?.dst_name ||
    singleMessageValue?.[0]?.src_name ||
    "Student";

  return (
    <Fragment>
      <AppHeader />
      <div className="app-main">
        <AppSidebar />
        <div className="app-main__outer">
          <div className="student-message-container">
            <div className="school-it-msg-header">
              <div>
                <h1 className="school-it-msg-title">Student Messages</h1>
                <p className="school-it-msg-subtitle">
                  View and reply to messages from students
                </p>
              </div>
              <div className="school-it-msg-header-actions">
                {totalUnread > 0 && (
                  <span className="school-it-msg-unread-pill">
                    {totalUnread} unread
                  </span>
                )}
                <button
                  onClick={createNewMessage}
                  className="school-it-create-btn"
                  type="button"
                >
                  <FontAwesomeIcon icon={faUser} />
                  Create Student Message
                </button>
              </div>
            </div>

            <div className="school_it-message-container">
              {loading ? (
                <CustomLoader />
              ) : (
                <div className="school-it-msg-list">
                  {messageDetails?.length > 0 ? (
                    messageDetails.map((item, index) => {
                      const unreadCount = getUnreadCountForItem(item);
                      return (
                        <div
                          key={item?.src_id || item?.id || index}
                          onClick={() => handleSinglePage(item, index)}
                          className={`schoolIT-student-message-container ${
                            messageIndex === index ? "message-active-class" : ""
                          }`}
                        >
                          <div className="school-it-msg-row">
                            <div className="school-it-msg-user">
                              <img
                                className="school-it-msg-avatar"
                                src={IMG_URL + "CounselorPlaceholder.png"}
                                alt=""
                              />
                              <div style={{ minWidth: 0 }}>
                                <p className="school-it-msg-name">
                                  {item?.priority === "critical" && (
                                    <span className="school-it-msg-critical">
                                      <FontAwesomeIcon
                                        icon={faExclamationCircle}
                                      />
                                    </span>
                                  )}
                                  {item?.name}
                                  {unreadCount > 0 && (
                                    <span
                                      className="school-it-msg-count"
                                      title={`${unreadCount} unread messages`}
                                    >
                                      {unreadCount > 99 ? "99+" : unreadCount}
                                    </span>
                                  )}
                                </p>
                                <p className="school-it-msg-preview">
                                  {item?.last_message}
                                </p>
                              </div>
                            </div>
                            <div className="school-it-msg-meta">
                              <p className="school-it-msg-time">
                                {moment(item.time).format(
                                  "ddd DD MMM YYYY, hh:mm A"
                                )}
                              </p>
                              <FontAwesomeIcon
                                onClick={(e) => deleteStudentMessage(e, item)}
                                icon={faTrash}
                                className="school-it-msg-delete"
                              />
                            </div>
                          </div>
                        </div>
                      );
                    })
                  ) : (
                    <div className="school-it-msg-empty-list">
                      No student messages yet
                    </div>
                  )}
                </div>
              )}

              {singleMessageOpen ? (
                <div className="school-it-msg-thread">
                  <p className="school-it-msg-thread-title">
                    Conversation with <strong>{conversationName}</strong>
                  </p>
                  <div className="school-it-msg-thread-body">
                    {threadLoading ? (
                      <CustomLoader />
                    ) : singleMessageValue?.length > 0 ? (
                      <>
                        {singleMessageValue.map((item, index) => {
                          if (item?.message_body === null) return null;
                          const received = isReceivedMessage(item);
                          return (
                            <div
                              key={item?.id || index}
                              className={`school-it-chat-row ${
                                received ? "is-received" : "is-sent"
                              }`}
                            >
                              <div className="school-it-chat-bubble">
                                <img
                                  className="school-it-chat-avatar"
                                  src={IMG_URL + "CounselorPlaceholder.png"}
                                  alt=""
                                />
                                <div className="school-it-chat-content">
                                  <p className="school-it-chat-name">
                                    {received
                                      ? item?.src_name || conversationName
                                      : "You"}
                                  </p>
                                  <p className="school-it-chat-text">
                                    {item.message_body}
                                  </p>
                                  {item.attachment_url ? (
                                    <div className="school-it-chat-attach">
                                      <a
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        href={item.attachment_url}
                                      >
                                        Download Attachment
                                      </a>
                                    </div>
                                  ) : null}
                                  <p className="school-it-chat-meta">
                                    {moment(item.date_sent)?.format(
                                      "DD MMM, hh:mm A"
                                    )}
                                  </p>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                        <div ref={threadEndRef} />
                      </>
                    ) : (
                      <div className="school-it-msg-empty-list">
                        No messages in this conversation
                      </div>
                    )}
                  </div>
                  <form className="school-it-msg-reply" onSubmit={sendMessage}>
                    <textarea
                      rows="2"
                      placeholder="Type your reply here..."
                      value={message}
                      onChange={(e) => setMessage(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" && !e.shiftKey) {
                          e.preventDefault();
                          sendMessage(e);
                        }
                      }}
                    />
                    <button
                      type="submit"
                      disabled={!message?.trim() || sending}
                      className={`school-it-msg-send-btn ${
                        message?.trim() ? "is-ready" : ""
                      }`}
                    >
                      {sending ? (
                        <MessageSendSpinner size={16} />
                      ) : (
                        <>
                          <FontAwesomeIcon icon={faPaperPlane} />
                          Send
                        </>
                      )}
                    </button>
                  </form>
                </div>
              ) : (
                <div className="school-it-msg-empty">
                  Select a student conversation to view messages
                </div>
              )}
            </div>

            {openCreateNewMessage && (
              <CreateMessage
                role="student"
                close={() => setOpenCreateNewMessage(false)}
                openCannedModal={openCannedModal}
                setOpenedCannedModal={setOpenedCannedModal}
                message={messageValueForCreateMessage}
                setMessage={setMessageValueForCreateMessage}
                getMessageDetails={() => {
                  getStudentMessage();
                  getNotificationData();
                }}
                selectedMessageFromScheduled={selectedMessageFromScheduled}
                allMessageValue={allMessageValue}
              />
            )}

            {openCannedModal && (
              <CannedModal
                open={openCannedModal}
                close={() => setOpenedCannedModal(false)}
                handleCannedMessageSelect={(value) =>
                  handleCannedMessageSelect(value)
                }
              />
            )}
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default StudentMessage;
